/* app/js/src/components/tenant/choose-template/templates-window/templates-window.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.scrollable-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.scrollable-container::-webkit-scrollbar-corner {
  background: transparent;
}
.scrollable-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.scrollable-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.scrollable-container::-webkit-scrollbar-thumb {
  border-width: 0;
}
.templates {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.scrollable-container {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: scroll;
  position: relative;
  margin-top: 9px;
}
/*# sourceMappingURL=templates-window.component.css.map */
